<!--
  SolidMeshPanel.vue — Thin wrapper that delegates to the appropriate
  structure-specific sub-panel based on the solidMesh's structureType.
-->
<template>
	<component :is="panelComponent" ref="subPanel" :solidMeshId="solidMeshId" :isEditing="isEditing" />
</template>

<script>
import { SIMPLE_STRUCTURE_TYPE } from "@/models/objects/solidMesh/types";
import { ObjectType } from "@/models/objects/types";
import SolidMeshPanelDoublePoint from "./SolidMeshPanelDoublePoint.vue";
import SolidMeshPanelManual from "./SolidMeshPanelManual.vue";
import SolidMeshPanelSinglePoint from "./SolidMeshPanelSinglePoint.vue";

export default {
	name: "SolidMeshPanel",
	components: {
		SolidMeshPanelDoublePoint,
		SolidMeshPanelSinglePoint,
		SolidMeshPanelManual,
	},
	props: {
		solidMeshId: String,
		isEditing: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		solidMesh() {
			return this.$store.state.object.objects.find(
				(obj) =>
					obj.type === ObjectType.SOLID_MESH && obj.id === this.solidMeshId,
			);
		},
		structureType() {
			return (
				this.solidMesh?.metaData?.attributes?.structureType ||
				this.solidMesh?.attributes?.structureType
			);
		},
		panelComponent() {
			if (
				this.structureType === SIMPLE_STRUCTURE_TYPE.PIPE ||
				this.structureType === SIMPLE_STRUCTURE_TYPE.RETAINING_WALL
			) {
				return "SolidMeshPanelDoublePoint";
			}
			if (
				this.structureType === SIMPLE_STRUCTURE_TYPE.BOX_CULVERT ||
				this.structureType === SIMPLE_STRUCTURE_TYPE.MANHOLE
			) {
				return "SolidMeshPanelSinglePoint";
			}
			return "SolidMeshPanelManual";
		},
	},
	methods: {
		/**
		 * Forward syncGradientFromReset to the sub-panel (used by SolidMeshListItem).
		 */
		syncGradientFromReset(resetRotation) {
			this.$refs.subPanel?.syncGradientFromReset?.(resetRotation);
		},
	},
};
</script>
